.page {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(120% 90% at 50% -10%, rgba(184, 150, 104, 0.08), transparent 55%),
    radial-gradient(140% 120% at 50% 120%, rgba(179, 71, 51, 0.06), transparent 60%),
    radial-gradient(100% 100% at 50% 35%, var(--ink-2), var(--ink) 80%);
}

.close {
  position: fixed;
  top: max(1.1rem, env(safe-area-inset-top));
  right: max(1.1rem, env(safe-area-inset-right));
  z-index: 42;
  font-family: var(--sans);
  font-size: 0.66rem;
  letter-spacing: 0.26em;
  text-transform: uppercase;
  color: var(--paper-faint);
  border: 1px solid var(--paper-ghost);
  border-radius: 999px;
  padding: 0.55em 1.1em;
  background: rgba(17, 16, 14, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition:
    color 0.4s var(--ease-soft),
    border-color 0.4s var(--ease-soft);
}
.close:hover,
.close:focus-visible {
  color: var(--paper);
  border-color: var(--gold-soft);
  outline: none;
}

.scroll {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: clamp(4.5rem, 12vh, 8rem) clamp(1.25rem, 5vw, 3rem) clamp(3rem, 12vh, 6rem);
}

.inner {
  width: 100%;
  max-width: 46rem;
}
